import { SortByItemLinks } from "@circle-react/components/Spaces/Header/SpaceHeaderActions/SortByDropdown";
import { Icon } from "@circle-react/components/shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { CustomizeHomeForm } from "./CustomizeHomeForm";
import { HomeDropdownOptions } from "./HomeDropdownOptions";
import { useManageFeedActionsV3 } from "./ManageFeedActionsV3/useManageFeedActionsV3";
import { Title } from "./Title";

export interface HomeHeaderTitleProps {
  defaultSort: string;
  hasDropdown?: boolean;
}

export const HomeHeaderTitle = ({
  defaultSort,
  hasDropdown = true,
}: HomeHeaderTitleProps) => {
  const {
    coverImage,
    shouldShowCustomizeHome,
    shouldShowCoverImageModal,
    shouldShowCustomizeModal,
    isCoverImageLoading,
    displayWelcomeBanner: shouldDisplayWelcomeBanner,
    initialSectionRef,
    toggleCoverImageModal,
    toggleCustomizeModal,
    toggleCustomizeModalWithSection,
    onAddCoverImage,
    isDataRefreshing,
  } = useManageFeedActionsV3();

  return (
    <>
      <div className="hidden lg:block">
        {shouldShowCustomizeHome && hasDropdown ? (
          <Dropdown
            direction="bottom-start"
            button={
              <Dropdown.MenuButton>
                <Title />
                <Icon size={16} type="caret-down-bold" className="text-dark" />
              </Dropdown.MenuButton>
            }
          >
            <HomeDropdownOptions
              toggleCoverImageModal={toggleCoverImageModal}
              toggleCustomizeModalWithSection={toggleCustomizeModalWithSection}
              displayWelcomeBanner={shouldDisplayWelcomeBanner}
              isCoverImageVisible={!!coverImage}
            />
          </Dropdown>
        ) : (
          <Title />
        )}
      </div>
      <div className="lg:hidden">
        <Dropdown
          direction="bottom-start"
          button={
            <Dropdown.MenuButton>
              <Title />
              <Icon size={16} type="caret-down-bold" className="text-dark" />
            </Dropdown.MenuButton>
          }
        >
          <SortByItemLinks defaultSort={defaultSort} />
        </Dropdown>
      </div>
      <CustomizeHomeForm
        shouldShowCoverImageModal={shouldShowCoverImageModal}
        toggleCoverImageModal={toggleCoverImageModal}
        shouldShowCustomizeModal={shouldShowCustomizeModal}
        toggleCustomizeModal={toggleCustomizeModal}
        initialSection={initialSectionRef.current}
        coverImage={coverImage}
        onAddCoverImage={onAddCoverImage}
        isCoverImageLoading={isCoverImageLoading}
        isDataRefreshing={isDataRefreshing}
      />
    </>
  );
};
